import React, { useMemo } from 'react';
import { Card } from 'flowbite-react';
import { DependencyNodeId } from 'sched';
import { useDependencies } from '../../hooks/useDependencies';
import { useDatabase } from '../../hooks/useDatabase';
import DependencyGraph from '../../components/graph/DependencyGraph';

const DependenciesPage: React.FC = () => {
  const { dependencies, loading, error } = useDependencies();
  const { dependencyGraph } = useDatabase();
  
  // Extract all unique node IDs from dependencies
  // TODO this may be unnecessary if they are already unique, as provided
  const nodeIds = useMemo(() => {
    if (!dependencies.length) return [];
    
    const uniqueNodeIds = new Set<DependencyNodeId>();
    
    dependencies.forEach(dep => {
      uniqueNodeIds.add(dep.by);
      uniqueNodeIds.add(dep.on);
    });
    
    return Array.from(uniqueNodeIds);
  }, [dependencies]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <Card>
          <h2 className="text-xl font-bold text-red-600">Error</h2>
          <p>{error}</p>
        </Card>
      </div>
    );
  }

  if (!dependencies.length) {
    return (
      <div className="p-4">
        <Card>
          <h2 className="text-xl font-bold">No Dependencies</h2>
          <p>There are no dependencies defined in this workspace.</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-4 h-full">
      <Card className="h-full">
        <div className="h-full">
          {nodeIds.length > 0 && dependencyGraph ? (
            <DependencyGraph nodeIds={nodeIds} maxNodes={50} />
          ) : (
            <div className="flex justify-center items-center h-full text-cm-text-muted">
              No dependencies found
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};

export default DependenciesPage;
